import { AfterViewInit, OnDestroy, Component, Inject, Input, OnInit, ViewChild } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { BankcardTicket, BankcardTicketsService } from '@ridango/components';
import { AppConfigService, AppStartupService } from '@ridango/core';

import { saveAs } from 'file-saver';
import { BaseComponent } from '@ridango/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { takeUntil } from 'rxjs/operators';
import Env from '@ridango/core/env';
@Component({
    selector: 'rwidget-bankcard-tickets-table',
    templateUrl: './bankcard-tickets-table.component.html',
    styleUrls: ['./bankcard-tickets-table.component.scss']
})
export class BankcardTicketsTableComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() tickets: BankcardTicket[];
    @Input() loading;
    @Input() regionId;

    @ViewChild(MatSort) sort: MatSort;

    purchaseTicketsTableColumns: string[];
    currency: string;
    dateFormat: string;

    dataSource: MatTableDataSource<BankcardTicket>;

    constructor(
        @Inject('ENV') public env: Env,
        public appStartupService: AppStartupService,
        private bankcardTicketsService: BankcardTicketsService,
        private translate: TranslateService,
        private appConfigService: AppConfigService
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.regionId) {
            const appProperties = this.appConfigService.getAppProperty(this.regionId);
            this.purchaseTicketsTableColumns = appProperties.purchaseTicketsTableColumns;
            this.currency = appProperties.currency;
            this.dateFormat = appProperties.dateFormat;
        }
        this.currency = this.currency ? this.currency : this.appStartupService.getCurrency();
        this.purchaseTicketsTableColumns = this.purchaseTicketsTableColumns
            ? this.purchaseTicketsTableColumns
            : this.env.PURCHASE_HISTORY_TICKETS_TABLE_COLUMNS;
        this.dateFormat = this.dateFormat ? this.dateFormat : this.env.BANKCARD_HISTORY_DATE_FORMAT;
    }

    ngAfterViewInit(): void {
        this.dataSource = new MatTableDataSource(this.tickets);
        this.dataSource.sort = this.sort;
    }

    getPdf(ticket: BankcardTicket) {
        this.bankcardTicketsService
            .fetchPDF(ticket.jwt_token, this.translate.currentLang)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(
                (d) => {
                    saveAs(d, `Receipt.pdf`);
                },
                (e) => {
                    console.log(`PDF error`);
                }
            );
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
